import { GroupConfigurationCategory } from '@/modules/group/modules/groups/domain/models/GroupConfigurationCategory'

import { axios, Response } from '../index'

export interface GetActivitiesForAPersonResponse {
  id: string
  name: string
  imageUrl: string
  activityType: ActivityType
  groupCategory: GroupConfigurationCategory
}

export enum ActivityType {
  PATIENT = 'PATIENT',
  GROUP = 'GROUP'
}

const getActivitiesForAPerson = (
  personaId: string
): Response<GetActivitiesForAPersonResponse[]> => {
  return axios.get(`/v1/personas/${personaId}/activities`)
}

export default getActivitiesForAPerson
